import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    d: 'M20.125 8.25012H19.5V6.37512C19.5 6.02887 19.22 5.75012 18.875 5.75012H3.875C2.84125 5.75012 2 6.59137 2 7.62512V18.8751C2 19.9089 2.84125 20.7501 3.875 20.7501H20.125C20.47 20.7501 20.75 20.4701 20.75 20.1251V8.87512C20.75 8.52887 20.47 8.25012 20.125 8.25012Z',
                    fill: '#2196F3',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M3.875 7.00012H18.25V8.25012H3.875C3.53 8.25012 3.25 7.97012 3.25 7.62512C3.25 7.28012 3.53 7.00012 3.875 7.00012Z',
                    fill: '#FAFAFA',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M21.375 15.7501H17.625C16.59 15.7501 15.75 14.9101 15.75 13.8751C15.75 12.8389 16.59 12.0001 17.625 12.0001H21.375C21.72 12.0001 22 12.2801 22 12.6251V15.1251C22 15.4701 21.72 15.7501 21.375 15.7501Z',
                    fill: '#1976D2',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M18.0108 8.2502L15.6833 3.5952C15.5283 3.28645 15.1533 3.1627 14.8446 3.3152L4.97705 8.2502H18.0108Z',
                    fill: '#4CAF50',
                },
            },
            {
                tag: 'path',
                attr: {
                    d: 'M3.25 8.25012H15.5112L13.1837 3.59512C13.0287 3.28637 12.6537 3.16262 12.345 3.31637L3.25 7.86387V8.25012Z',
                    fill: '#81C784',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const WalletColored = React.forwardRef(IconComponent);
WalletColored.displayName = 'WalletColored';

export { WalletColored };
